import { useMemo } from 'react';

type TQueryData<TFragment> = {
  count: number;
  meta: { page: number; limit: number };
  nodes: TFragment[];
};

export default function useQueryDataTableProps<TFragment>(data?: TQueryData<TFragment>) {
  return useMemo(() => {
    if (!data) {
      return { pagination: undefined, nodes: undefined };
    }
    const { nodes, count, meta } = data;
    return { nodes, pagination: { count, page: meta.page, limit: meta.limit } };
  }, [data]);
}
